import {
    IonButton,
    IonButtons,
    IonCard,
    IonContent,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonSpinner,
    IonText,
    IonTitle,
    IonToolbar,
} from "@ionic/react";
import { trashOutline } from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../../store/rootReducer";
import { setDeselectAll, setDeselectOrganization } from "../../../store/userProfileOrganization";
import { selectOrganizationsSelected } from "../../../store/userProfileOrganization/selectors/selectOrganizationsSelected";
import { OrganizationSelectedSearchBar } from "./OrganizationSelectedSearchBar";

export const OrganizationSelected = () => {
    const dispatch = useDispatch();
    const selectedOrganizations = useSelector((state: RootState) => state.userProfileOrganization.selectedOrganizations);
    const organizations = useSelector(selectOrganizationsSelected);
    const findProfileOrganizationStatus = useSelector((state: RootState) => state.userProfileOrganization.findProfileOrganizationStatus)
 
    return (
        <IonCard style={{ height: "75vh" }} class="ion-no-margin">
            <IonToolbar color="primary">
                <IonTitle size="small" style={{ fontWeight: 500 }}>
                    Seleccionados ({selectedOrganizations.length})
                </IonTitle>
                <IonButtons slot="end">
                    {!!selectedOrganizations.length && (
                        <IonButton
                            fill="solid"
                            color="danger"
                            onClick={() => {
                                dispatch(setDeselectAll());
                            }}
                            size="small"
                        >
                            <small>Quitar todos</small>
                            <IonIcon icon={trashOutline} slot="end" />
                        </IonButton>
                    )}
                </IonButtons>
            </IonToolbar>
            <OrganizationSelectedSearchBar />
            <IonContent style={{ overlay: "scroll", height: "60vh" }}>
                <IonList>
                    {findProfileOrganizationStatus === "succeeded" && organizations.map((item) => (
                        <IonItem key={item.id}>
                            <IonLabel className="ion-hide-md-up" text-wrap>
                                <h5 style={{ fontWeight: 700 }}>
                                    <IonText color="primary">{item.name}</IonText>
                                </h5>
                            </IonLabel>
                            <IonLabel className="ion-hide-md-down" text-wrap>
                                <h3 style={{ fontWeight: 700 }}>
                                    <IonText color="primary">{item.name}</IonText>
                                </h3>
                            </IonLabel>
                            <IonButton
                                expand="block"
                                fill="clear"
                                onClick={() => {
                                    dispatch(setDeselectOrganization(item));
                                }}
                                size="default"
                            >
                                <IonIcon icon={trashOutline} />
                            </IonButton>
                        </IonItem>
                    ))}
                    {findProfileOrganizationStatus === "pending" && (
                        <p className="ion-text-center">
                            <IonSpinner />
                        </p>
                    )}
                </IonList>
            </IonContent>
        </IonCard>
    );
};